import { createContext, useContext } from "react";
import parentStore from "./parent";
import teacherStore from "./teacher";
import childStore from "./child";
import curClass from "./class";
import curEPanel from "./engagementPanel";
import curModule from "./module";
import curTalkingParty from "./talkingParty";

export const globalStores = {
  parentStore,
  teacherStore,
  childStore,
  curClass,
  curEPanel,
  curModule,
  curTalkingParty,
};

export const GlobalStoreContext = createContext(globalStores);

export const useGlobalStore = () => {
  return useContext(GlobalStoreContext);
};
